import React from "react";
import { Avatar } from "flowbite-react";
import { HiOutlineUserGroup, HiOutlineClock } from "react-icons/hi";
import { formatCurrency } from "../../../utils/formatCurrency";
import { formatDistanceToNow } from "date-fns";
import { useFamilyActivity } from "../hooks/useFamilyActivity";
import { getTextColor } from "../../transactions/utils/transactionFormatters";

export const FamilyActivity: React.FC = () => {
  const { data } = useFamilyActivity();
  const activities = data?.activities || [];

  return (
    <div className="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-sm">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold flex items-center gap-2">
          <HiOutlineUserGroup className="text-indigo-500" />
          Family Activity
        </h2>
        <div className="flex items-center gap-2 text-sm text-gray-500">
          <HiOutlineClock className="w-4 h-4" />
          Live Updates
        </div>
      </div>

      <div className="space-y-6">
        {activities.map((activity, index) => (
          <ActivityItem key={index} {...activity} />
        ))}
      </div>
    </div>
  );
};

interface ActivityItemProps {
  memberName: string;
  memberAvatar: string;
  action: string;
  amount: number;
  category: string;
  merchant: string;
  timestamp: Date;
  type: "Income" | "Expense" | "Transfer";
}

const ActivityItem: React.FC<ActivityItemProps> = ({
  memberName,
  memberAvatar,
  action,
  amount,
  category,
  merchant,
  timestamp,
  type,
}) => (
  <div className="flex items-start gap-4 p-4 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-700/50 transition-colors">
    <Avatar img={memberAvatar} rounded size="md" />

    <div className="flex-1 min-w-0">
      <div className="flex items-center justify-between mb-1">
        <div className="font-medium truncate">{memberName}</div>
        <span className={`font-semibold ${getTextColor(type)}`}>
          {formatCurrency(amount)}
        </span>
      </div>

      <div className="text-sm text-gray-600 dark:text-gray-300">
        {action} at <span className="font-medium">{merchant}</span>
      </div>

      <div className="flex items-center gap-2 mt-2 text-sm">
        <span className="px-2 py-1 rounded-full bg-gray-100 dark:bg-slate-700 text-gray-600 dark:text-gray-300">
          {category}
        </span>
        <span className="text-gray-500">
          {formatDistanceToNow(timestamp, { addSuffix: true })}
        </span>
      </div>
    </div>
  </div>
);
